module.exports = __webpack_public_path__ + "static/media/location_branch.cdcf422a.svg";